import { useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let id = useDataValue({
    context: 'card',
    viewPath: props.viewPath,
    path: 'patient.id',
  })

  return function onClick() {
    window.open(
      `${window.location.protocol}//${window.location.host}/patients/${id}`,
      '_blank'
    )
  }
}
